import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Button,
  Box,
  Typography,
  CircularProgress,
  Chip,
  debounce,
  Avatar,
  styled,
  Badge,
  IconButton,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { notificationMarkAsRead } from "../../../api/notificationMarkAsRead";
import { notificationDelete } from "../../../api/deleteNotification";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-dot": {
    right: "52px",
    top: "21px",
    // border: `2px solid ${(theme.vars ?? theme).palette.background.paper}`,
    padding: "0 3px",
    backgroundColor: "#d93349",
    color: "white",
  },
}));

const NotificationData = ({ data }) => {
  // const [markAsRead, setMarkAsRead] = useState(false);
  // const [clear, setClear] = useState(false);
  const [hoverState, setHoverState] = useState(false);
  const token = useSelector((state) => state.auth.token);

  const handleMarkAsRead = async (id) => {
    try {
      if (token && id) {
        const data = await notificationMarkAsRead(id, token);
        if (data.success) {
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      }
    } catch (error) {
      toast.error("error !!");
    }
  };

  const handleDelete = async (id) => {
    try {
      if (token && id) {
        const data = await notificationDelete(id, token);
        if (data.success) {
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      }
    } catch (error) {
      toast.error("error !!");
    }
  };

  return (
    <Box
      className={!data.is_read ? "notification-div unread" : "notification-div"}
      onMouseEnter={() => setHoverState(true)}
      onMouseLeave={() => setHoverState(false)}
    >
      <Box className="wrapper">
        {!data.is_read ? (
          <StyledBadge variant="dot">
            <Avatar
              src={data.user_commented?.profile_img}
              alt={`${data.user_commented.firstName} ${data.user_commented.lastName}`}
            />
          </StyledBadge>
        ) : (
          <Avatar
            src={data.user_commented?.profile_img}
            alt={`${data.user_commented.firstName} ${data.user_commented.lastName}`}
          />
        )}
        <Box className="text">
          <Typography component="p">{data.message_text}</Typography>
          <Typography component="p" sx={{ opacity: "60%" }}>
            {moment(data.createdAt).format("hh:mm a")}
          </Typography>
        </Box>
        <Box className="info">{/* {"extra data"} */}</Box>
        {hoverState && (
          <Box className="info">
            {!data.is_read ? (
              <IconButton onClick={() => handleMarkAsRead(data.id)}>
                <Tooltip title="Mark as read" placement="top">
                  <DoneAllIcon sx={{ color: "white" }} />
                </Tooltip>
              </IconButton>
            ) : (
              ""
            )}
            <IconButton onClick={() => handleDelete(data.id)}>
              <Tooltip title="Delete" placement="top">
                <DeleteForeverIcon sx={{ color: "white" }} />
              </Tooltip>
            </IconButton>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default NotificationData;
